import React, { useContext, useEffect, useRef, useState } from 'react';

import {API, getCountries} from '../../services/api';
import { Link, useNavigate } from 'react-router-dom';

import AuthContext from '../../components/shared/AuthContext';
import { useTranslation } from 'react-i18next';
import LangSwitcher from '../../components/langSwitcher';

import Swal from 'sweetalert2';
import OrgContext from '../../organisation/OrgContext';

function Register(props) {

    const [t, i18n] = useTranslation();

    const [countries, setCountries] = useState([]);
    const [showPass, setShowPass] = useState(false);

    const username = useRef("");
    const email = useRef("");
    const nick_name = useRef("");
    const phone = useRef("");
    const gender = useRef("");
    const country = useRef("");
    const password = useRef("");
    const password2 = useRef("");

    const { register, setUser }= useContext(AuthContext);

    const navigate = useNavigate();

    const {changeOrg} = useContext(OrgContext);

    const [isActive, setIsActive] = useState(false);

    useEffect(()=>{
        const fetchCountries = () => {
            getCountries()
            .then((data)=> setCountries(data))
            .catch((err) => console.error(err));
        };

        fetchCountries();
        
    }, []);

    const submit = async (event) => {

        event.preventDefault();

        if(
            username.current.value.trim().length > 0
            && email.current.value.trim().length > 0
            && password.current.value.trim().length > 0
            && password2.current.value.trim().length > 0
            && phone.current.value.trim().length > 0
            && nick_name.current.value.trim().length > 0
            && gender.current.value.trim().length > 0
            && country.current.value.trim().length > 0
        ){
            

            if(password.current.value != password2.current.value){
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('password and confirmation password are not same'),
                });
                return;
            }

            if(password.current.value.length < 6){
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('The password field must be at least 6 characters.'),
                });
                return;
            }
            
            let payload = {
                name: username.current.value,
                email: email.current.value,
                password: password.current.value,
                phone: phone.current.value,
                nick_name: nick_name.current.value,
                gender: gender.current.value,
                country: country.current.value
            };

            try {
                
                const response = await register(payload);
                if(response.data.user.is_active == 1){
                    localStorage.setItem("tokens",  JSON.stringify(response.data));
                    if(response.data.organisations){
                        if(response.data.organisations.length > 0){
                            if(!localStorage.getItem("orgs")){
                                changeOrg(response.data.organisations[0]);
                            }
                        }else{
                            setUser(response.data.user);
                            navigate("/organisation_profile");
                            window.location.reload();
                            return;
                        }
                    }
                    setUser(response.data.user);
                    window.location.reload();
                }else{
                    setIsActive(true);
                }
                
            } catch (error) {
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: 'Something went wrong!, try again',
                });
            }
    
            

        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('Fill all fields'),
            });
        }
        


    }

    const showPassword = (event) => {
        event.preventDefault();
        setShowPass(!showPass);
    }

    return (
        <div className="login-img">
            <div className="page">
                <div className="">

                    {/* <!-- CONTAINER OPEN --> */}
                    <div className="col col-login mx-auto mt-7">
                        <div className="text-center">
                            {/* <img src="../assets/images/brand/logo-white.png" className="header-brand-img m-0" alt="" /> */}
                        </div>
                    </div>
                    {isActive ? (<div className='row'>
                        <div className='col-sm-4'></div>
                        <div className='col-sm-4'>
                            <div className="card border p-0 pb-3">
                                    <div className="card-header border-0 pt-3">
                                        <div className="card-options">
                                            
                                        </div>
                                    </div>
                                    <div className="card-body text-center">
                                        <span className=""><svg xmlns="http://www.w3.org/2000/svg" height="60" width="60" viewBox="0 0 24 24"><path fill="#13bfa6" d="M10.3125,16.09375a.99676.99676,0,0,1-.707-.293L6.793,12.98828A.99989.99989,0,0,1,8.207,11.57422l2.10547,2.10547L15.793,8.19922A.99989.99989,0,0,1,17.207,9.61328l-6.1875,6.1875A.99676.99676,0,0,1,10.3125,16.09375Z" opacity=".99"></path><path fill="#71d8c9" d="M12,2A10,10,0,1,0,22,12,10.01146,10.01146,0,0,0,12,2Zm5.207,7.61328-6.1875,6.1875a.99963.99963,0,0,1-1.41406,0L6.793,12.98828A.99989.99989,0,0,1,8.207,11.57422l2.10547,2.10547L15.793,8.19922A.99989.99989,0,0,1,17.207,9.61328Z"></path></svg></span>
                                        <h4 className="h4 mb-0 mt-3">Succès</h4>
                                        <p className="card-text">{t("Votre compte a été créé avec succès, veuillez patienter lorsque l'administrateur active votre compte, et vous pouvez vous connecter au tableau de bord")}</p>
                                    </div>
                                    <div className="card-footer text-center border-0 pt-0">
                                        <div className="row">
                                            <div className="text-center">
                                                <a 
                                                    onClick={()=>{
                                                        setIsActive(false);
                                                    }}
                                                className="btn btn-success">{t("Fermer")}</a>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div className='col-sm-4'></div>
                    </div>):null}
                    {!isActive ? (<div className="container" style={{ width: 400 }}>
                        <div className="wrap-login100 p-6">
                            <form className="login100-form validate-form">
                                <span className="login100-form-title">
                                        {t("Registration")}
                                    </span>
                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                    <span className="input-group-text bg-white text-muted">
                                        <i className="mdi mdi-account" aria-hidden="true"></i>
                                    </span>
                                    <input ref={username} className="input100 border-start-0 ms-0 form-control" type="text" placeholder={t("Name")} />
                                </div>
                                
                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                    <span className="input-group-text bg-white text-muted">
                                        <i className="mdi mdi-account" aria-hidden="true"></i>
                                    </span>
                                    <input ref={nick_name} className="input100 border-start-0 ms-0 form-control" type="text" placeholder={t("Nick name")} />
                                </div>
                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                    <span  className="input-group-text bg-white text-muted">
                                        <i className="zmdi zmdi-email" qaria-hidden="true"></i>
                                    </span>
                                    <input ref={email} className="input100 border-start-0 ms-0 form-control" type="email" placeholder={t("Your Email")} />
                                </div>
                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                    <span  className="input-group-text bg-white text-muted">
                                        <i className="zmdi zmdi-phone" qaria-hidden="true"></i>
                                    </span>
                                    <input ref={phone} className="input100 border-start-0 ms-0 form-control" type="phone" placeholder={t("Phone")} />
                                </div>
                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                    <span  className="input-group-text bg-white text-muted">
                                        <i className="mdi mdi-account" qaria-hidden="true"></i>
                                    </span>
                                    <select ref={gender} name="gender" className="form-control form-select" placeholder={t("Select Gender")}>
                                        <option value="male">{t("Male")}</option>
                                        <option value="female">{t("Female")}</option>
                                    </select>
                                </div>
                                <div className="wrap-input100 validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
                                    <span  className="input-group-text bg-white text-muted">
                                        <i className="zmdi zmdi-globe" qaria-hidden="true"></i>
                                    </span>
                                    <select ref={country} name="country" className="form-control form-select" placeholder={t("Select Country")}>
                                        { countries.map((c) => <option key={c.id} value={c.id}>{c.nicename}</option>)}
                                    </select>
                                </div>
                                <div className="wrap-input100 validate-input input-group" id="Password-toggle">
                                    <span  className="input-group-text bg-white text-muted">
                                        <i className="zmdi zmdi-lock-outline" aria-hidden="true"></i>
                                    </span>
                                    <input ref={password} className="input100 border-start-0 ms-0 form-control" name='password' type={!showPass ? "password" : "text"} placeholder={t("Password")} />
                                    <button onClick={showPassword} className="input-group-text bg-white text-muted">
                                        {showPass ? <i className="zmdi zmdi-eye-off" aria-hidden="true"></i> : <i className="zmdi zmdi-eye" aria-hidden="true"></i>}
                                    </button>
                                </div>
                                <div className="wrap-input100 validate-input input-group" id="Password-toggle">
                                    <span  className="input-group-text bg-white text-muted">
                                        <i className="zmdi zmdi-lock-outline" aria-hidden="true"></i>
                                    </span>
                                    <input ref={password2} className="input100 border-start-0 ms-0 form-control" name='password2' type={!showPass ? "password" : "text"} placeholder={t("Password confirmation")} />
                                    
                                </div>
                                
                                <div className="container-login100-form-btn">
                                    <button  className="login100-form-btn btn-primary"  onClick={submit}>
                                            {t("Register")}
                                        </button>
                                </div>
                                <div className="text-center pt-3">
                                    <p className="text-dark mb-0">{t("Already have account?")}<Link className="text-primary ms-1" to="/login">{t("Sign In")}</Link></p>
                                </div>
                                
                            </form>
                        </div>
                    </div>) : false}
                    {/* <!-- CONTAINER CLOSED --> */}
                </div>
                <LangSwitcher />
            </div>
        </div>
    );
}

export default Register;